export default __webpack_public_path__ + "static/media/RollerCoaster_AlongTrack_v001_2.912ab2fd.gif";